import { OutputScale } from './OutputScale';
import { approximateFraction, floorToDivide } from './pdfUIUtils';

export type SetPDFPageCanvasSizeParams = {
  canvas: HTMLCanvasElement;
  width: number;
  height: number;
  maxCanvasPixels: number;
};

export const setPDFPageCanvasSize = ({ canvas, width, height, maxCanvasPixels }: SetPDFPageCanvasSizeParams) => {
  const outputScale = new OutputScale();

  const pixelsInViewport = width * height;
  const maxScale = Math.sqrt(maxCanvasPixels / pixelsInViewport);

  if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
    outputScale.sx = maxScale;
    outputScale.sy = maxScale;
  }

  const sfx = approximateFraction(outputScale.sx);
  const sfy = approximateFraction(outputScale.sy);

  canvas.width = floorToDivide(width * outputScale.sx, sfx[0]);
  canvas.height = floorToDivide(height * outputScale.sy, sfy[0]);

  canvas.style.width = floorToDivide(width, sfx[1]) + 'px';
  canvas.style.height = floorToDivide(height, sfy[1]) + 'px';

  // Rendering area
  const transform = outputScale.scaled ? [outputScale.sx, 0, 0, outputScale.sy, 0, 0] : undefined;

  return {
    transform,
  };
};
